import React from 'react';
import isNil from 'lodash.isnil';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import ExternalLinkWrapper from '../../navigation/ExternalLinkWrapper';
import { getUrlParams, getUrlString } from '../../../utils/shared/urlUtils';
import { PARAM, INTERVENTION_GROUP_URL } from '../../../constants/reading/ApiConstants';

const { BURST_GROUP_ID, BURST_SCHOOL_UID, BURST_DISTRICT_UID, BURST_SEMESTER } = PARAM;

const InterventionGroupLink = ({ groupData, location, className }) => {
    const { district, school } = getUrlParams(location);
    const { groupId, groupName } = groupData;
    const burstGroupUrl = getUrlString(INTERVENTION_GROUP_URL, {
        [BURST_DISTRICT_UID]: isNil(district) ? null : district.replace('P', ''),
        [BURST_SCHOOL_UID]: school,
        [BURST_SEMESTER]: get(groupData, 'groupSemester', 'spring'),
        [BURST_GROUP_ID]: groupId,
    });
    return <ExternalLinkWrapper path={burstGroupUrl} content={groupName} className={className} />;
};

InterventionGroupLink.defaultProps = {
    className: null,
    groupData: {},
    location: {},
};

InterventionGroupLink.propTypes = {
    className: PropTypes.string,
    groupData: PropTypes.object,
    location: PropTypes.object,
};

export default InterventionGroupLink;
